// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2QIAd","option":"styles_option__193kG","selected":"styles_selected__3DgYy"};